import http from "../utils/api";
import localforage from "../utils/localforage";
import moment from "moment";
import formatDate from "../utils/formatDate";
import {getHollydays} from './hollydays.service';
import {setColaborador} from '../utils/storage';
import { getFerias } from "./ferias.service";
import { getColaboradorAcessos } from "./colaboradorAcesso.service";
import { getSaldoHorasDia } from "./saldo-horas-dia.service";

export async function getHorasMes({
                                      cb = () => {
                                      }
                                  }) {
    await http.get('apontamentos/periodo?data=' + moment().format('YYYY-MM-DD')).then(async ({data}) => {
        await localforage.setItem('periodo', data.data);
        http.get('apontamentos', {
            params: {
                dataHoraInicio: formatDate(moment(data.data.inicio).subtract(1, 'months').set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                })),
                dataHoraFim: formatDate(moment(data.data.fim).set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                    millisecond: 999
                })),
            }
        }).then(async ({data}) => {
            await localforage.setItem('horas-mes', data.data);
            cb();
        });
    });

    await http.get(`apontamentos/saldo-horas?data=${moment().format("YYYY-MM-DD")}`)
     .then(async ({ data }) => {
    await localforage.removeItem('saldo-horas');
    await localforage.setItem('saldo-horas', data.data);
    });

    getSaldoHorasDia();
}

export function getPendencia(id) {
    return http.get('atividades-alocadas/pendencia', {
        params: {
            idPendencia: id
        }
    });
}

export async function initSystem() {
    setTimeout(async () => {
        await getColaboradorAcessos();
        await http.get('colaborador').then(({data}) => {
            setColaborador(data);
        })
        await http.get('classificacoes-horas').then(async ({data}) => {
            await localforage.setItem('classificacoes-horas', data.data);
        }).catch(console.log);
        await http.get('tipos-atividade').then(async ({data}) => {
            await localforage.setItem('tipos-atividade', data.data);
        });
        const filterApontamento = await localforage.getItem('filter-apontamento');
        const dataAlocacaoInicio = filterApontamento?.dataHoraInicio;
        const dataAlocacao = dataAlocacaoInicio && moment(dataAlocacaoInicio).isValid()
            ? moment(dataAlocacaoInicio).format('YYYY-MM-DD')
            : null;
        await http.get('projetos-atividade', {
            params: {
                qtdeItens: 9999,
                dataAlocacao,
            }
        }).then(async ({data}) => {
            await localforage.setItem('projetos-atividade', data.data);
        });

        await getHorasMes({});
        await getHollydays();
        await getFerias();
    }, 2000)
}

export async function initSystemLiderado() {
    setTimeout(async () => {
        await http.get('classificacoes-horas').then(async ({data}) => {
            await localforage.setItem('classificacoes-horas', data.data);
        }).catch(console.log);
        await http.get('tipos-atividade').then(async ({data}) => {
            await localforage.setItem('tipos-atividade', data.data);
        });
        const filterApontamento = await localforage.getItem('filter-apontamento');
        const dataAlocacaoInicio = filterApontamento?.dataHoraInicio;
        const dataAlocacao = dataAlocacaoInicio && moment(dataAlocacaoInicio).isValid()
            ? moment(dataAlocacaoInicio).format('YYYY-MM-DD')
            : null;
        await http.get('projetos-atividade', {
            params: {
                qtdeItens: 9999,
                dataAlocacao,
            }
        }).then(async ({data}) => {
            await localforage.setItem('projetos-atividade', data.data);
        });

        await getHorasMes({});
        await getHollydays();
        await getFerias();
    }, 2000)
}
